import React, { useState,useEffect,useRef } from 'react';
import { connect } from 'react-redux';
import themeSettings from '../../../commons/styles/themeSettings.json';
import localStorage from '../../../utils/localStorage';
import { StyledForm } from './CSS/style';
import './CSS/style.css';
import StyledTable from '../../../commons/styles/table';
// import { DrawerFooter } from '../../../commons/styles/layout';
import {
  FormUpdate,
  FormSubmission,
  getUserList,
 // getRelatedTags,
  getStatusList,
  getDeployHistory,
  SubmitForm
} from '../APICalls/FormCalls';
// import Index from './index';
// import { constant } from '../Utils/Constants';
import moment from 'moment';
import { ANALYTICS } from '../../../commons/api';
//import axios from 'axios';
import {
  Button,
  Form,
  Input,
  message,
  Select,
  Upload,
  Drawer,
  Tooltip,
  Badge
  // Space,
} from 'antd';
// import translation from '../Utils/translation';
import { StyledTab, LightTheme } from '../../../commons/styles/tab';
import { useNavigate } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import CommentsForm from '../Details/CommentsForm';
import {
  EditOutlined,
  PlusOutlined,
  FieldTimeOutlined,
  UserOutlined,
  UploadOutlined,
  DownloadOutlined,
  CommentOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
// const { Option } = Select;
const { TextArea } = Input;
const { Option } = Select;

const APIList = {
  getList: `${ANALYTICS.UseCaseGet}`,
  Create: `${ANALYTICS.PredictionCreate}`,
  Update: `${ANALYTICS.PredictionUpdate}`,
  Get: `${ANALYTICS.TrainingJobGet}`,
  GetById: `${ANALYTICS.TrainingJobGetById}`,
  getById: `${ANALYTICS.PredictionGetById}`
};
// const { RangePicker } = DatePicker;
const Tasks = (props) => {
  const [formObject,setFormObject] = useState ({});
  const [dataSource,setDataSource] = useState([]);
  const [translationCache,setTranslationCache] = useState(props.translationCache || {});
  const [userProfile,setUserProfile] = useState(props && props.userProfile ? props.userProfile : {});
//const [predictionResultsdataSource,setPredictionResultsdataSource] = useState([]);
  const [statusList,setStatusList] = useState([]);
  const [predictionfileModalVisible,setPredictionfileModalVisible] = useState(false);
 // const [predictionResultsFileModalVisible,setPredictionResultsFileModalVisible] = useState(false);
 // const [addResults,setAddResults] = useState(false);
 // const [isPredictionResultVisible,setIsPredictionResultVisible] = useState(false);
 // const [editAddResult,setEditAddResult] = useState(false);
  const [useCaseModalVisible,setUseCaseModalVisible] = useState(false);
  // const [remarksModalVisible,setRemarksModalVisible] = useState(false);
 // const [predictionResultInd,setPredictionResultInd] = useState('');
  // const [useCaseName,setUseCaseName] = useState ('');
  const [users,setUsers] =useState('');
  //const [actionKey,setActionKey] = useState('');
  const [searchText,setSearchText] =useState('');
  const [searchedColumn,setSearchedColumn] =useState('');
  const [dataObj] =useState('');
  const [AnalyticsId,setAnalyticsId] = useState([]);
  const [Type,setType] = useState([]);
  //const [TaskId,setTaskId] = useState('');
  //const [relatedTags,setRelatedTags]= useState('');
  //const [lastBreadcrumb,setLastBreadcrumb] = useState([]);
  const [breadcrumbList,setBreadcrumbList] = useState ([
      {
        title: '',
        key: 'home',
        type: 'home'
      }
    ]);
  // const hForm = React.createRef();
 // const predictionRef = React.createRef();
  const searchInputRef = useRef(null);
  const hForm = useRef(null);
  const predictionRef = useRef(null);
  const navigate = useNavigate();
  //const predictionResultRef = React.createRef();

  
  useEffect(()=>{
    getTasksInitialData();
  },[]);
  useEffect(()=>{
    if (
      translationCache !== props.translationCache ||
      props.userProfile !== userProfile
    ) {
      
        setTranslationCache(props.translationCache);
        setUserProfile(props.userProfile);
     
    }
      getTasksInitialData();
    
  },[translationCache,userProfile,props.translationCache,props.userProfile]);

 const getTasksInitialData = async () => {
    let searchParams = new URLSearchParams(props.location.search);
    let newParams = Object.fromEntries(searchParams.entries());    
    let Type =newParams && newParams.Type ? newParams.Type : null;
    let AnalyticsId =newParams && newParams.AnalyticsId ? newParams.AnalyticsId : null;

    setAnalyticsId(AnalyticsId);
    setType(Type);
    const pathSnippets = props.location.pathname
      .split(`/rubus/RubusAnalytics/Tasks/`)
      .filter((i) => i);
    if (pathSnippets && pathSnippets[0]) {
      const useCaseLevel = pathSnippets[0].split('/').filter((i) => i);
      if (useCaseLevel && useCaseLevel[useCaseLevel.length - 1] !== 'New') {

        const payload = {
          AnalyticsId: AnalyticsId,
          Id: useCaseLevel[useCaseLevel.length - 1],
          // Type: Type
        };
        let formObject = await SubmitForm(payload, APIList.getById);

        if (formObject && formObject !== null) {
          // formObject = {
          //   ...formObject,
          //   Date: [moment(formObject.Date[0]), moment(formObject.Date[1])]
          // };
          hForm.current &&
            hForm.current.setFieldsValue({
              TaskName: formObject && formObject.TaskName,
              Id: formObject && formObject.Id,
              // RelatedTags: formObject.RelatedTags,
              // Date: formObject.Date,
              CreatedBy: formObject && formObject.CreatedBy,
              AssignedBy: formObject && formObject.AssignedBy,
              Status: formObject.Status,
              Approach: formObject.Approach,
              // Algorithms: formObject.Algorithms,
              CreatedTime:
                formObject &&
                formObject.CreatedTime &&
                moment(formObject.CreatedTime).format('YYYY-MM-DD HH:mm:ss'),
              Comments: formObject && formObject.Comments,
              useCaseName: formObject && formObject.useCaseName,
              Description: formObject && formObject.Description,
              Attachments: formObject && formObject.Attachments
              // Results: formObject.Results
            });
          let response = await getDeployHistory(APIList.Get, 'TaskId', formObject.Id);
          setFormObject(formObject);
          setBreadcrumbList(formObject && formObject.Path);
         // setLastBreadcrumb(Type);
          setDataSource(response && Array.isArray(response) ? response : []);
          setType(formObject && formObject.Type);
        }
      } else {
        let path = props && props.location && props.location.state && props.location.state.breadcrumbList;
        let data = [];
        if (Type && Type === 'Prediction') {
          data = [
            {
              title: 'Prediction Task',
              key: 'Prediction',
              type: 'Prediction'
            }
          ];
        } else if (Type && Type === 'Analysis') {
          data = [
            {
              title: 'Analysis Task',
              key: 'Analysis',
              type: 'Analysis'
            }
          ];
        }

        const PathList = path.concat(data);
        setBreadcrumbList(PathList);
        let obj = {
          TaskName: null,
          Id: null,
          // RelatedTags: [],
          CreatedBy:
          props &&
          props.userProfile &&
          props.userProfile.user &&
          props.userProfile.user.Id,
          CreatedTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          AssignedBy: null,
          Status: '',
          Approach: '',
          // Algorithms: '',
          Comments: [],
          useCaseName: null,
          Description: null,
          Attachments: []
          // Results: []
        };
        hForm.current &&
          hForm.current.setFieldsValue({
            CreatedBy:
              props &&
              props.userProfile &&
              props.userProfile.user &&
              props.userProfile.user.Id,
            CreatedTime: moment().format('YYYY-MM-DD HH:mm:ss')
          });
          setFormObject(obj);
      }


      let list = await getUserList();
      //let relatedTags = await getRelatedTags();
      let statusList = await getStatusList();
     
      // setUseCaseName(useCaseLevel && useCaseLevel[useCaseLevel.length - 1]);
      setUsers(list);
     // setRelatedTags(relatedTags);
      setStatusList(statusList);
      
      
    }
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  // const editList = async (Id) => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   const object = {
  //     method: 'GET',
  //     url: `${APIList.getList}?SiteId=${siteId}&Id=${Id}&Type=Usecase`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   return axios(object)
  //     .then((response) => {
  //       return response.data;
  //     })
  //     .catch(function () { });
  // };
  const changeOnBreadCrumb =  (breadCrumb, e, index) => {
    // setActionKey('onchange');
    let value = [...breadcrumbList];
    let data = value.splice(0, index + 1);

    let dataVal = data[data.length - 1];
    if (dataVal && dataVal.type === 'usecase') {
      let Id = dataVal && dataVal.Id;
      if (Id !== undefined) {
        navigate(`/rubus/RubusAnalytics/usecase/${dataVal.Id}`,
        );
      }
    }
  };

  const _editRecord = (record) => {
    navigate(
      `/rubus/RubusAnalytics/TrainningJob/${record.Id}?TaskId=${formObject.Id}`
    );
  };
  const addTrainingJob = () => {
    navigate(
      `/rubus/RubusAnalytics/TrainningJob/New?TaskId=${formObject.Id}`,
     
         breadcrumbList,
     
    );
  };
//  const  onChangeAddResult = (value, resultKey, resultIndex, key) => {
//     formObject[resultKey][resultIndex][key] = value;
//     setFormObject(formObject);
//   };

  const onFinish =  () => {
    //  let formObject = hForm.current && hForm.current.getFieldsValue();
    let data = hForm.current && hForm.current.getFieldsValue();
    let value = [];
    value.push(dataObj);
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async () => {
          if (formObject && formObject.AnalyticsId) {
            let payload = {
              ...data,
              Comments: formObject && formObject.Comments,
              Attachments: formObject && formObject.Attachments,
              CreatedTime:
                data &&
                data.CreatedTime &&
                moment(data.CreatedTime).utc().format('YYYY-MM-DD HH:mm:ss'),
              // RelatedTags: data.RelatedTags,
              AssignedBy: data && data.AssignedBy,
              Status: data && data.Status,
              // Results: formObject.Results,
              Type: formObject && formObject.Type
            };
            let Final = {};
            if (formObject && formObject.Type && formObject.Type === 'Prediction') {
              Final = {
                PredictionTask: [payload],
                Id: formObject.Id
              };
            } else if (formObject && formObject.Type && formObject.Type === 'Analysis') {
              Final = {
                AnalyticsTask: [payload],
                Id: formObject.Id
              };
            }
            let UpdateResponse = await FormUpdate(Final, APIList.Update);
            if (UpdateResponse && UpdateResponse.status === 200) {
              message.success(UpdateResponse && UpdateResponse.data && UpdateResponse.data.message);

              let payload = {
                AnalyticsId: AnalyticsId,
                Id: formObject.Id,
                Type: formObject && formObject.Type
              };
              let TaskData = await SubmitForm(payload, APIList.getById);
              TaskData = {
                ...TaskData,
                CreatedTime: moment(TaskData.CreatedTime).format('YYYY-MM-DD HH:mm:ss')
              };

              hForm.current &&
                hForm.current.setFieldsValue({
                  TaskName: TaskData && TaskData.TaskName,
                  Id: TaskData && TaskData.Id,
                  // RelatedTags: TaskData.RelatedTags,
                  // Date: TaskData.Date,
                  CreatedBy: TaskData && TaskData.CreatedBy,
                  AssignedBy: TaskData && TaskData.AssignedBy,
                  Status: TaskData && TaskData.Status,
                  Approach: TaskData && TaskData.Approach,
                  // Algorithms: TaskData.Algorithms,
                  CreatedTime: TaskData && TaskData.CreatedTime,
                  Comments: TaskData && TaskData.Comments,
                  useCaseName: TaskData && TaskData.useCaseName,
                  Description: TaskData && TaskData.Description,
                  Attachments: TaskData && TaskData.Attachments
                  // Results: TaskData.Results
                });
              navigate(
                `/rubus/RubusAnalytics/Tasks/${TaskData.Id}?AnalyticsId=${AnalyticsId}&Type=${Type}`
              );
              let response = await getDeployHistory(APIList.Get, 'TaskId', TaskData.Id);
              setBreadcrumbList(TaskData && TaskData.Path);
              //setLastBreadcrumb(Type);
              setFormObject(TaskData);
             // setTaskId(formObject && formObject.Id,);
              setAnalyticsId(AnalyticsId);
              setDataSource(response && Array.isArray(response) ? response : []);
            } else {
              message.error(UpdateResponse && UpdateResponse.data && UpdateResponse.data.message);
            }
          } else {
            let payload = {
              ...data,
              Comments: formObject && formObject.Comments,
              Attachments: formObject && formObject.Attachments,
              // RelatedTags: data.RelatedTags,
              AssignedBy: data && data.AssignedBy,
              Status: data && data.Status,
              CreatedTime:
                data &&
                data.CreatedTime &&
                moment(data.CreatedTime).utc().format('YYYY-MM-DD HH:mm:ss'),
              // Results: formObject.Results,
              Type: Type
            };
            let Final = {};
            if (Type && Type === 'Prediction') {
              Final = {
                PredictionTask: [payload],
                Id: AnalyticsId
              };
            } else if (Type && Type === 'Analysis') {
              Final = {
                AnalyticsTask: [payload],
                Id: AnalyticsId
              };
            }
            let createResponse = await FormSubmission(Final, APIList.Create);
            if (createResponse && createResponse.status === 200) {
              message.success(createResponse && createResponse.data && createResponse.data.message);

              let payload = {
                AnalyticsId: AnalyticsId,
                Id: createResponse.data.Id,
                Type: Type
              };
              let TaskData = await SubmitForm(payload, APIList.getById);
              TaskData = {
                ...TaskData,
                CreatedTime: moment(TaskData.CreatedTime).format('YYYY-MM-DD HH:mm:ss')
              };

              hForm.current &&
                hForm.current.setFieldsValue({
                  TaskName: TaskData && TaskData.TaskName,
                  Id: TaskData && TaskData.Id,
                  // RelatedTags: TaskData.RelatedTags,
                  // Date: TaskData.Date,
                  CreatedBy: TaskData && TaskData.CreatedBy,
                  AssignedBy: TaskData && TaskData.AssignedBy,
                  Status: TaskData && TaskData.Status,
                  Approach: TaskData && TaskData.Approach,
                  // Algorithms: TaskData.Algorithms,
                  CreatedTime: TaskData && TaskData.CreatedTime,
                  Comments: TaskData && TaskData.Comments,
                  useCaseName: TaskData && TaskData.useCaseName,
                  Description: TaskData && TaskData.Description,
                  Attachments: TaskData && TaskData.Attachments
                  // Results: TaskData.Results
                });
              navigate(
                `/rubus/RubusAnalytics/Tasks/${createResponse.data.Id}?A=${AnalyticsId}&Type=${Type}`
              );
              let response = await getDeployHistory(APIList.Get, 'TaskId', TaskData.Id);

              setBreadcrumbList(TaskData && TaskData.Path);
              //setLastBreadcrumb(Type);
              setFormObject(TaskData);
              //setTaskId(createResponse.data.Id);
              setAnalyticsId(AnalyticsId);
              setDataSource(response && Array.isArray(response) ? response : []);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };

//  const  onChange = (value, dateString) => {
//     setRange([dateString[0], dateString[1]]);
//     setMomentRange([moment(dateString[0]), moment(dateString[1])]);
//   };

//  const disabledDate = (current) => {
//     return current > moment().endOf('day');
//   };

  const fileUpload = (info, key, index) => {
    // let formObject = hForm.current.getFieldsValue();
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject && formObject[key] && formObject[key][index]) {
        if (formObject[key][index]['Attachments']) {
          formObject[key][index]['Attachments'] =
            formObject &&
              formObject[key] &&
              formObject[key][index] &&
              formObject[key][index]['Attachments']
              ? formObject[key][index]['Attachments']
              : [];

          formObject[key][index]['Attachments'].push({
            Id: id,
            file: Name,
            Type: Type,
            AnalyticsId: AnalyticsId
          });
        } else {
          formObject[key][index]['Attachments'] = [];
          formObject[key][index]['Attachments'].push({
            Id: id,
            file: Name,
            Type: Type,
            AnalyticsId: AnalyticsId
          });
        }
      } else {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments']
              ? formObject['Attachments']
              : [];
          formObject['Attachments'].push({
            Id: id,
            file: Name,
            Type: Type,
            AnalyticsId: AnalyticsId
          });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({
            Id: id,
            file: Name,
            Type: Type,
            AnalyticsId: AnalyticsId
          });
        }
      }
      setFormObject(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

 const handlePredictionTasksClick = (e) => {
    // let { formObject } = this.state;
    if (e === 'Add New Attachments') {
      predictionRef.current && predictionRef.current.click();
    } else {
      setPredictionfileModalVisible(true);
    }
  };

//  const handleOkPrediction = () => {
//   setIsPredictionResultVisible(false);
//   setAddResults(true);
//   setEditAddResult(true);
//     // remarksModalVisible:true
//   };

  // const handleCancelPrediction = () => {
  //   setIsPredictionResultVisible(false);
  //   setAddResults(true);
  // };
  // const editResults = (item, itemId, resInd, key) => {
  //   if (key === 'EditAddResult') {
  //     setIsPredictionResultVisible(true);
  //     setPredictionResultInd(resInd);
     
  //   }
  // };

  // const deleteResult = (val, key, index) => {
    
  //   // if (key === 'EditAddResult') {
  //   let newArray = formObject.Results.filter((item, i) => i !== index);
  
  //   setFormObject({
  //     formObject: [{ ...formObject, Results: newArray }]
  //   })
  // };

  // const add3Dots = (text, limit) => {
  //   let dots = '...';
  //   if (text.length > limit) {
  //     text = text.substring(0, limit) + dots;
  //   }
  //   return text;
  // };

  // const addPredictionResults = () => {
 
  //   if (formObject && !formObject.Results) {
  //     formObject['Results'] = [];
  //   }
  //   let useCaseobj1 = {
  //     // ...formObject,
  //     Description: '',
  //     CreatedBy:
  //       props &&
  //       props.userProfile &&
  //       props.userProfile.user &&
  //       props.userProfile.user.Id,
  //     CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  //     Comments: [],
  //     Attachments: []
  //   };
  //   formObject && formObject.Results && formObject.Results.push(useCaseobj1);
  //   setFormObject({ ...formObject });
  //   setAddResults(true);
  //   setEditAddResult(false);
  //   setIsPredictionResultVisible(true);
  // };

 const useCaseModalClose = () => {
    setUseCaseModalVisible(false);
  };
  // const resultsModalClose = () => {
  //   setRemarksModalVisible(false);
  // };
  const SubmitComments = (value, key, index) => {
    // let formObject = hForm.current.getFieldValue();
    if (formObject && formObject[key] && formObject[key][index]) {
      if (formObject[key][index]['Comments'] !== undefined) {
        formObject[key][index]['Comments'].push(
          ...value.filter((item) => {
            return item.Id === undefined;
          })
        );
        formObject[key][index]['Comments'] = formObject[key][index]['Comments'].filter(
          (obj, Index) => {
            return (
              Index ===
              formObject[key][index]['Comments'].findIndex((o) => obj.Comment === o.Comment)
            );
          }
        );
      } else {
        formObject[key][index]['Comments'] = value;
      }
    } else {
      if (formObject['Comments'] !== undefined) {
        formObject['Comments'].push(
          ...value.filter((item) => {
            return item.Id === undefined;
          })
        );
        formObject['Comments'] = formObject['Comments'].filter((obj, Index) => {
          return Index === formObject['Comments'].findIndex((o) => obj.Comment === o.Comment);
        });
      } else {
        formObject['Comments'] = value;
      }
    }
   
    setFormObject(formObject);
    setUseCaseModalVisible(false);
    // setRemarksModalVisible(false);
    // this.hForm.current.setFieldsValue(formObject);
  };
  // const handlePredictionResultsClick = (e, key) => {
  //   if (e === 'Add New Attachments') {
  //     predictionResultRef.current.click();
  //   } else {
  //     setPredictionResultsFileModalVisible(true),
  //     setPredictionResultsdataSource(formObject &&
  //       formObject['Results'] &&
  //       formObject['Results'][key] &&
  //       formObject['Results'][key]['Attachments']
  //       ? [...formObject['Results'][key]['Attachments']]
  //       : [])
  //   }
  // };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
 const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  
    const userName =
     props &&
     props.userProfile &&
     props.userProfile.user &&
     props.userProfile.user.Id;
    const columns = [
      {
        title:translation('Training Job Name'),
        dataIndex: 'Name',
        key: 'Name',
        ...getColumnSearchProps('Name')
      },
      {
        title:translation('Description'),
        dataIndex: 'Description',
        key: 'Description'
      },
      {
        title:translation('Action'),
        width: '600',
        render: (text, record) => (
          <>
            <Button
              style={{ marginRight: '5px' }}

              onClick={() => {
               _editRecord(record);
              }}
              
            >
              <Tooltip title={translation('Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
          </>
        )
      }
    ];

    const columnsPrediction = [
      {
        title: 'File',
        dataIndex: 'file',
        key: 'file',
        align: 'center'
      },
      {
        title: 'Action',
        width: '600',
        align: 'center',
        render: (text, record) => (
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div style={{ marginLeft: '-25px' }}>
                <a href={`http://192.168.95.23:3001/api/IOTAAttachments/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
        )
      }
    ];
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const formItemLayout = { width: '100%', flex: '50%' };
    let items = [
      {
        key: '1',
        label: 'Training Jobs',
        children: (
          <div>
            {formObject && formObject.Id && formObject.Id !== undefined ? (
              <div style={{ float: 'right' }}>
                <Tooltip title={translation('Add Training Job')}>
                  <PlusOutlined
                    onClick={addTrainingJob}
                    style={{
                      
                      color: 'rgb(255, 108, 0)',
                      marginLeft: '10px',
                      paddingBottom: '20px',
                      paddingRight: '20px'
                    }}
                  />
                </Tooltip>
              </div>
            ) : null}
            <div>
              <StyledTable size="small"
                dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
                columns={columns}
              />
            </div>
          </div>
        ),
      }
    ];
    return (
      <>
        <div
          style={{
            margin: '10px'
          }}
        >
          <Breadcrumb
            style={{
              padding: '20px 0px 10px 35px',
              color: 'white',
              fontWeight: '800'
            }}
            separator=">"
            className="_Bredacrumb_"
          >
            {breadcrumbList &&
              Array.isArray(breadcrumbList) &&
              breadcrumbList.map((breadcrumb, index) => {
                if (
                  breadcrumb &&
                  breadcrumb.type &&
                  breadcrumb.type === 'home' &&
                  breadcrumbList.length === 1
                ) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {''}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.type && breadcrumb.type === 'home') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if ((breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') &&
                  (breadcrumb && breadcrumb.Id)) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/${breadcrumb.Id}?AnalyticsId=${AnalyticsId}&Type=${Type}`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if ((breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis')) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/New`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.Id) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/${breadcrumb.Id}`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/New`}
                        onClick={(e) =>changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
          </Breadcrumb>

          <>
            <StyledForm
              name="Training Jobs"
              theme={themeSettings}
              ref={hForm}
              onFinish={onFinish}
              onKeyDown={(e) => {
                e.key === 'Enter' && e.preventDefault();
              }}
              initialValues={formObject || {}}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              labelWrap
              wrapperCol={{ flex: 1 }}
            // validateMessages={validateMessages}
            >
              <div style={{ marginTop: '24px', display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  labelCol={{ flex: '200px' }}
                  label="Title"
                  name={'TaskName'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide Title'
                    }
                  ]}
                >
                  <Input
                    maxLength={10000}
                    
                    style={{ width: '70%' }}
                    placeholder="Input Title"
                  />
                </Form.Item>
                <Form.Item
                  label="Assigne"
                  name={'AssignedBy'}
                  placeholder="Select 'Assigne'"
                  style={formItemLayout}
                >
                  <Select placeholder="Search Assigne" style={{ width: '70%' }}>
                    {users &&
                      Array.isArray(users) &&
                      users.map((item, index) => {
                        return (
                          <Option key={index} value={item.Id}>
                            {item.UserName}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item
                  labelCol={{ flex: '200px' }}
                  name={'Description'}
                  label="Functional Description"
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide FunctionalDescription'
                    }
                  ]}
                >
                  <TextArea
                    maxLength={10000}
                    style={{
                      height: 100,
                      width: '70%'
                    }}
                    placeholder="Input FunctionalDescription"
                  />
                </Form.Item>
                <Form.Item
                  labelCol={{ flex: '200px' }}
                  label="Approach"
                  name={'Approach'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide Approach'
                    }
                  ]}
                >
                  <TextArea
                    maxLength={10000}
                    style={{
                      height: 100,
                      width: '70%'
                    }}
                    placeholder="Input Approach"
                  />
                </Form.Item>
                {/* <Form.Item
                  label="Related Tags"
                  name={'RelatedTags'}
                  placeholder="Select Tags"
                  style={formItemLayout}
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    placeholder="Search RelatedTags"
                    style={{ width: '70%' }}
                  >
                    {relatedTags &&
                      Array.isArray(relatedTags) &&
                      relatedTags.map((item, index) => {
                        return (
                          <Option key={index} value={item.Value}>
                            {item.Key}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item> */}

                <Form.Item
                  label="Status"
                  name={'Status'}
                  placeholder="Select Status"
                  style={formItemLayout}
                >
                  <Select
                    placeholder="Search Status"
                    style={{ width: '70%' }}
                    disabled={formObject && formObject.Status ? false : true}
                  >
                    {statusList &&
                      Array.isArray(statusList) &&
                      statusList.map((item, index) => {
                        return (
                          <Option key={index} value={item.Key}>
                            {item.Key}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                {/* <Form.Item
                  label="From And To Date"
                  name={'Date'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Select From And To Date'
                    }
                  ]}
                >
                  <RangePicker
                    style={{ width: '70%' }}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder={['Start DateTime', 'End DateTime']}
                    value={this.state.momentRange}
                    onChange={this.onChange}
                    onOk={this.onhandleRangepicker}
                    disabledDate={this.disabledDate}
                  />
                </Form.Item> */}

                {/* <Form.Item
                  // labelCol={{ flex: '200px' }}
                  label="Algorithms"
                  name={'Algorithms'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide Algorithms'
                    }
                  ]}
                >
                  <Input
                    maxLength={10000}
                    
                    style={{ width: '70%' }}
                    placeholder="Input Algorithms"
                  />
                </Form.Item> */}
                <Form.Item
                  // labelCol={{ flex: '130px' }}
                  style={formItemLayout}
                  name={'Attachments'}
                  // name={['PredictionTasks', Index, 'Attachments']}
                  label="Attachments"
                >
                  <div>
                    <Select
                      
                      style={{ width: '70%' }}
                      placeholder={'Add/View Attachments'}
                      onChange={(e) =>handlePredictionTasksClick(e)}
                    >
                      <Option key={'View Attachments'} value={'View Attachments'}>
                        View Attachments
                      </Option>
                      <Option key={'Add New Attachments'} value={'Add New Attachments'}>
                        Add New Attachments
                      </Option>
                    </Select>
                    <Upload
                      multiple={true}
                      onChange={(info) =>fileUpload(info)}
                      action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'Task'}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <Button
                        style={{ display: 'none' }}
                        ref={predictionRef}
                        className="uploadFile"
                      >
                        <UploadOutlined /> Upload
                      </Button>
                    </Upload>
                    <Drawer
                      title={
                        Type && Type === 'Prediction'
                          ? 'Prediction Task Uploaded Files'
                          : 'Analysis Task Uploaded Files'
                      }
                      className="PredictionTaskUploadedFiles"
                      open={predictionfileModalVisible}
                      width={600}
                      onOk={() =>
                      
                        setPredictionfileModalVisible(false)
                      }
                      onClose={() =>
                        setPredictionfileModalVisible(false)
                      }
                    >
                      <StyledTable size="small"
                        columns={columnsPrediction}
                        dataSource={
                          formObject &&
                            formObject.Attachments &&
                            Array.isArray(formObject.Attachments) &&
                            formObject.Attachments
                            ? [...formObject.Attachments]
                            : []
                        }
                      />
                    </Drawer>
                  </div>
                </Form.Item>
                <Form.Item style={formItemLayout} label="Comments" name={'Comments'}>
                  <div>
                    <Tooltip
                      placement="topLeft"
                      color={'red'}
                      title="Click Here To Add Your Comments"
                    >
                      <Badge
                        count={formObject && formObject['Comments'] && formObject['Comments'].length}
                      >
                        <Button
                          style={{ background: '#eabe6f', color: 'black' }}
                          onClick={() => setUseCaseModalVisible(true)}
                        >
                          <CommentOutlined />
                          Add/View Comments
                        </Button>
                      </Badge>
                    </Tooltip>
                    {useCaseModalVisible && useCaseModalVisible === true ? (
                      <CommentsForm
                        Comments={
                          formObject && formObject['Comments'] && formObject['Comments'] !== undefined
                            ? [...formObject['Comments']]
                            : []
                        }
                        Title={'UseCase Comments'}
                        visible={useCaseModalVisible}
                        modalClose={useCaseModalClose}
                        user={userName}
                        Type={Type}
                        AnalyticsId={AnalyticsId}
                        submitComments={SubmitComments}
                      />
                    ) : null}
                  </div>
                </Form.Item>
                <Form.Item style={formItemLayout} label="Created By" name={'CreatedBy'}>
                  <Select
                    disabled
                    value={
                      props &&
                      props.userProfile &&
                      props.userProfile.user &&
                      props.userProfile.user.Id
                    }
                    suffix={<UserOutlined />}
                    
                    placeholder="Select CreatedBy"
                    style={{ width: '70%' }}
                  >
                    {users &&
                      Array.isArray(users) &&
                      users.map((item, index) => {
                        return (
                          <option key={index} value={item.Id}>
                            {item.FirstName}
                          </option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item style={formItemLayout} label="Created Date" name={'CreatedTime'}>
                  <Input
                    disabled
                    
                    style={{ width: '30%' }}
                    placeholder="CreatedDate"
                    suffix={<FieldTimeOutlined />}
                  />
                </Form.Item>
            
              </div>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={onFinish}>
                    Submit
                  </Button>
                </Form.Item>
              </div>
            </StyledForm>
            {/* <div style={{ float: 'right' }}> */}
            <StyledTab theme={LightTheme} defaultActiveKey="1" type="card" items={items} />
          </>
        </div>
      </>
    );
  
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(Tasks);

